var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownDotsDark = function SvgDropdownDotsDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "20px",
    viewBox: "0 0 6 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icons/Dots")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HY-App-Setting-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-9.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dots",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    opacity: 0.200000003,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75,9.5 C20.1307119,9.5 21.25,10.6192881 21.25,12 C21.25,13.3807119 20.1307119,14.5 18.75,14.5 C17.3692881,14.5 16.25,13.3807119 16.25,12 C16.25,10.6192881 17.3692881,9.5 18.75,9.5 Z M11.75,9.5 C13.1307119,9.5 14.25,10.6192881 14.25,12 C14.25,13.3807119 13.1307119,14.5 11.75,14.5 C10.3692881,14.5 9.25,13.3807119 9.25,12 C9.25,10.6192881 10.3692881,9.5 11.75,9.5 Z M4.75,9.5 C6.13071187,9.5 7.25,10.6192881 7.25,12 C7.25,13.3807119 6.13071187,14.5 4.75,14.5 C3.36928813,14.5 2.25,13.3807119 2.25,12 C2.25,10.6192881 3.36928813,9.5 4.75,9.5 Z",
    id: "Combined-Shape",
    fill: "#212529"
  }))))));
};
export default SvgDropdownDotsDark;